import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    input: ({ theme }) => ({
      fontSize: '14px',
      lineHeight: 1.5,
      fontWeight: 500,
      borderRadius: '10px',
      '&:not(.MuiInputBase-inputMultiline):not(.application-input):not(.MuiInputBase-inputSizeSmall)': {
        padding: '26px 16px 6px',
        boxSizing: 'border-box',
      },
      '&.MuiInputBase-inputMultiline': { padding: '2px 0 0 4px' },
      '&.MuiInputBase-inputSizeSmall': { padding: '10px 16px' },
      '&.Mui-disabled': {
        WebkitTextFillColor: 'inherit',
        backgroundColor: 'inherit',
      },
      '&::-webkit-calendar-picker-indicator, &::-webkit-inner-spin-button': {
        display: 'none',
      },
      '&.MuiInputBase-inputAdornedStart': {
        paddingLeft: '4px !important',
      },
      [`@media screen and (max-width: ${theme.breakpoints.values.sm}px)`]: {
        fontSize: '16px',
        lineHeight: 1.3,
      },
    }),
    root: () => ({
      height: '60px',
      '&.MuiInputBase-sizeSmall': {
        height: '44px',
      },
      '&.MuiInputBase-multiline': {
        height: 'auto',
      },
    }),
  },
};
